import { kycSumsubConstants } from '../constant/kyc-sumsub.constant';

const initialState = {
    isLoading: false,
    error: null,
    steps: [],
};

export function kycSumsubReducer(state = initialState, action) {
    switch (action.type) {
        case kycSumsubConstants.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload.isLoading,
            };

        case kycSumsubConstants.SET_ERROR:
            return {
                ...state,
                error: action.payload.error,
            };
        case kycSumsubConstants.UPDATE_STEP: {
            const { index, updatedStepData } = action.payload;
            const updatedSteps = [...state.steps];
            updatedSteps[index] = {
                ...updatedSteps[index],
                ...updatedStepData,
            };
            return {
                ...state,
                steps: updatedSteps,
            };
        }
        default:
            return state;
    }
}
